module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"row\" style=\"padding: 3px;\">\r\n    <div class=\"col-md-8\">\r\n        <div class=\"current-behavior\"></div>\r\n    </div>\r\n    <div class=\"col-md-4 \" style=\"text-align: right;\">\r\n        <div title=\"Show all active behaviors\" id=\"activeBehaviorsButton\" class=\"activeBehaviors\">\r\n            <span title=\"Show all active behaviors\" class=\"fa fa-angle-left\"></span>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div class=\"behaviors-list\" tabindex=\"100\">\r\n    <div class=\"row close-behaviors\">Close All</div>\r\n</div>")
  }
  return __output;

}